/** @jsx jsx */

import React from "react";
import { jsx, css } from "@emotion/core";
import { Row, Col } from "antd";

import { color } from "../../theme/Theme";
import jitfinLogo from "../../assets/jitfin-white.svg";

interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * Creates 2 different frames in a single page.
 * The first frame always displays the jitfin logo
 * and second displays children prop accepted by the component.
 */

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children
}: AuthLayoutProps) => (
  <Row css={AuthLayoutStyles} type="flex">
    <Col
      xs={0}
      sm={12}
      className="branding d-none d-sm-flex justify-content-center align-items-center"
    >
      <img src={jitfinLogo} alt="JitFin" />
    </Col>
    <Col xs={24} sm={12} className="page-content">
      {children}
    </Col>
  </Row>
);

const AuthLayoutStyles = css({
  ".page-content": {
    height: "100vh",
    overflowY: "auto"
  },
  ".branding": {
    background: color.greenBackground
  },
  ".ant-input-number": {
    width: "3.5rem"
  },
  ".country-code": {
    ".ant-input-number-input": {
      paddingRight: 0,
      color: color.primary
    }
  }
});

export default AuthLayout;
